import React, { FC } from 'react';

const ArrowIndicationSimulationSvg: FC<{ color: string }> = ({ color }) => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="12" height="8" viewBox="0 0 12 8" fill="none">
			<path
				d="M0.119944 4.77154L1.09245 2.45633L2.44413 1.24873L3.8991 0.180775L5.5696 1.09367L6.51141 1.83791L7.18801 1.80434L7.658 0.771131L8.9041 2.06878L10.2889 3.59261L10.5364 1.63822L11.0652 0.139516L11.8645 3.24254L11.3366 4.74473L10.6841 5.12669L10.0896 6.67102L9.45602 7.75119L8.22533 5.8313L7.05477 3.94727L6.14619 3.33203L4.64004 3.05717L3.0033 4.14827L1.89266 5.56284L0.119944 4.77154Z"
				fill={color}
			/>
		</svg>
	);
};

export default ArrowIndicationSimulationSvg;
